import { ComponentProps, ReactNode, useState } from "react";
import { Button } from "../../../shared/ui/button";
import "./achievement-modal.scss";
import { useAppSelector } from "../../../hooks/hooks";
import {
  selectLanguage,
  selectTranslations,
} from "../../../shared/data-access/store/general/generalSlice";
import { checkTranslationKey } from "../../../utils/translation";
import { shareBadge } from "../../../utils/share-badge";

export interface AchievementProps extends ComponentProps<"div"> {
  badge: string;
  badgeSlot?: ReactNode;
  title: string;
  buttonText: string;
  children: string;
  buttonClick: () => void;
}

export function BadgeModal({
  badge,
  badgeSlot,
  children,
  title,
  buttonText,
  buttonClick,
  ...props
}: AchievementProps) {
  const lang = useAppSelector(selectLanguage);
  const translations = useAppSelector(selectTranslations);
  const [sharing, setSharing] = useState(false);

  /**
   * Every badge opened in this modal is shareable, so the card is composed from the props rather
   * than from anything badge-specific.
   */
  const handleShare = async () => {
    setSharing(true);

    try {
      await shareBadge({ badge, title, description: children });
    } finally {
      setSharing(false);
    }
  };

  return (
    <div className="achievement-modal-container" {...props}>
      <div className="badge-header">
        {/* Optional slot for custom badge content */}
        {badgeSlot ? (
          <div className="badge-slot">{badgeSlot}</div>
        ) : (
          <img src={badge} height="200px" alt="" />
        )}
      </div>
      <div className="badge-content">
        <div className="badge-title">{title}</div>
        <div className="badge-text">{children}</div>
        <div className="share-area">
          <Button buttonType="white" onClick={buttonClick}>
            {buttonText}
          </Button>
          <Button
            buttonType="success-play"
            onClick={handleShare}
            disabled={sharing}
          >
            {checkTranslationKey(translations[lang]?.Share, "Share")}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default BadgeModal;
